<div
    class="input-group rating-field"
    role="group"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-invalid]="isInvalid()"
    [class.is-valid]="isValid()"
    [class.is-invalid]="isInvalid()"
>
    @for (rating of ratings(); track rating) {
        <button
            class="btn rating-star"
            type="button"
            [disabled]="!editable()"
            [class.filled]="isFilled(rating)"
            [attr.aria-label]="ariaLabel() + ' ' + rating"
            [attr.aria-pressed]="isFilled(rating)"
            (click)="rate(rating)"
        >
            <fa-icon [icon]="isFilled(rating) ? faStar : farStar" size="2x"></fa-icon>
        </button>
    }
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
